/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Kiotviet_Sync_StartedInputs */

const vi_customer_kiotviet_sync_started = /** @type {(inputs: Customer_Kiotviet_Sync_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã bắt đầu đồng bộ KiotViet`)
};

/**

* @param {Customer_Kiotviet_Sync_StartedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_kiotviet_sync_started = /** @type {((inputs?: Customer_Kiotviet_Sync_StartedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Kiotviet_Sync_StartedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_kiotviet_sync_started(inputs)
});